var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M10 14v6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-6h-3zm3-1a1 1 0 0 1 1 1v6a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-6a1 1 0 0 1 1-1h3zm0 2h-3v1h3v-1zM4 3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4zm15 4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v1h.5A2.5 2.5 0 0 1 22 7.5v1a2.5 2.5 0 0 1-2.5 2.5h-6a1.5 1.5 0 0 0-1.5 1.5v.5h-1v-.5a2.5 2.5 0 0 1 2.5-2.5h6A1.5 1.5 0 0 0 21 8.5v-1A1.5 1.5 0 0 0 19.5 6H19v1z" })
  );
});